import { type ReactNode, useId } from 'react';
import { cn } from '@/shell/lib/cn';

type SectionProps = {
  title: string;
  /** Einordnungszeile unter der Überschrift („Satz vor Zahl“). */
  summary?: string;
  /** Aktion rechts neben der Überschrift, z. B. „Alle Ziele“. */
  action?: ReactNode;
  className?: string;
  children: ReactNode;
};

/**
 * Bereich einer Seite: Überschrift (h2), feine Linie oben und Weißraum statt schwebender Karten
 * (Gestaltungsgrundsatz 3). Der Bereich ist über `aria-labelledby` benannt.
 */
export function Section({ title, summary, action, className, children }: SectionProps) {
  const headingId = useId();
  return (
    <section aria-labelledby={headingId} className={cn('border-t border-line pt-6', className)}>
      <header className="mb-5 flex flex-wrap items-start justify-between gap-x-6 gap-y-2">
        <div className="min-w-0">
          <h2 id={headingId} className="text-h2 font-semibold text-ink">
            {title}
          </h2>
          {summary === undefined ? null : (
            <p className="mt-1 max-w-[72ch] text-body text-ink-muted">{summary}</p>
          )}
        </div>
        {action === undefined ? null : <div className="shrink-0">{action}</div>}
      </header>
      {children}
    </section>
  );
}
